import { useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';
import { useAuth } from '../context/AuthContext';

/**
 * Returns the current user's credit balance from Firestore in real time.
 * Returns null while the initial snapshot is loading or while the user is not signed in.
 */
export function useCredits() {
  const { user } = useAuth();
  const [credits, setCredits] = useState(null);

  useEffect(() => {
    if (!user) {
      setCredits(null);
      return undefined;
    }
    const ref = doc(db, 'users', user.uid);
    const unsub = onSnapshot(ref, (snap) => {
      setCredits(snap.exists() ? (snap.data()?.credits ?? 0) : 0);
    });
    return unsub;
  }, [user]);

  return credits;
}
